// import { sectionRenderer } from '@theme/section-renderer';
// import { Component } from '@theme/component';
// import { FilterUpdateEvent, ThemeEvents } from '@theme/events';
// import { debounce, formatMoney, startViewTransition } from '@theme/utilities';

// const SEARCH_QUERY = 'q';

// class FacetsFormComponent extends Component {
//   requiredRefs = ['facetsForm'];

//   createURLParameters(formData = new FormData(this.refs.facetsForm)) {
//     let newParameters = new URLSearchParams(/** @type any */ (formData));

//     if (newParameters.get('filter.v.price.gte') === '') newParameters.delete('filter.v.price.gte');
//     if (newParameters.get('filter.v.price.lte') === '') newParameters.delete('filter.v.price.lte');

//     newParameters.delete('page');

//     const searchQuery = this.#getSearchQuery();
//     if (searchQuery) newParameters.set(SEARCH_QUERY, searchQuery);

//     return newParameters;
//   }

//   #getSearchQuery() {
//     const url = new URL(window.location.href);
//     return url.searchParams.get(SEARCH_QUERY) ?? '';
//   }

//   get sectionId() {
//     const id = this.getAttribute('section-id');
//     if (!id) throw new Error('Section ID is required');
//     return id;
//   }

//   #updateURLHash() {
//     const url = new URL(window.location.href);
//     const urlParameters = this.createURLParameters();

//     url.search = '';
//     for (const [param, value] of urlParameters.entries()) {
//       url.searchParams.append(param, value);
//     }

//     history.pushState({ urlParameters: urlParameters.toString() }, '', url.toString());
//   }

//   updateFilters = () => {
//     this.#updateURLHash();
//     this.dispatchEvent(new FilterUpdateEvent(this.createURLParameters()));
//     this.#updateSection();
//   };

//   #updateSection() {
//     const viewTransition = !this.closest('dialog');

//     // After the section re-renders, re-init all price sliders
//     const afterRender = () => {
//       document.querySelectorAll('price-facet-component[data-range-max]').forEach((el) => {
//         if (el instanceof PriceFacetComponent) el.initSlider();
//       });
//     };

//     if (viewTransition) {
//       startViewTransition(
//         () => sectionRenderer.renderSection(this.sectionId).then(afterRender),
//         ['product-grid']
//       );
//     } else {
//       sectionRenderer.renderSection(this.sectionId).then(afterRender);
//     }
//   }

//   updateFiltersByURL(url) {
//     history.pushState('', '', url);
//     this.dispatchEvent(new FilterUpdateEvent(this.createURLParameters()));
//     this.#updateSection();
//   }
// }

// if (!customElements.get('facets-form-component')) {
//   customElements.define('facets-form-component', FacetsFormComponent);
// }

// class FacetInputsComponent extends Component {
//   get sectionId() {
//     const id = this.closest('.shopify-section')?.id;
//     if (!id) throw new Error('FacetInputs component must be a child of a section');
//     return id;
//   }

//   updateFilters() {
//     const facetsForm = this.closest('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;
//     facetsForm.updateFilters();
//     this.#updateSelectedFacetSummary();
//   }

//   handleKeyDown(event) {
//     if (!(event.target instanceof HTMLElement)) return;
//     const closestInput = event.target.querySelector('input');
//     if (!(closestInput instanceof HTMLInputElement)) return;
//     if (event.key === 'Enter' || event.key === ' ') {
//       event.preventDefault();
//       closestInput.checked = !closestInput.checked;
//       this.updateFilters();
//     }
//   }

//   prefetchPage = debounce((event) => {
//     if (!(event.target instanceof HTMLElement)) return;
//     const form = this.closest('form');
//     if (!form) return;
//     const formData = new FormData(form);
//     const inputElement = event.target.querySelector('input');
//     if (!(inputElement instanceof HTMLInputElement)) return;
//     if (!inputElement.checked) formData.append(inputElement.name, inputElement.value);
//     const facetsForm = this.closest('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;
//     const urlParameters = facetsForm.createURLParameters(formData);
//     const url = new URL(window.location.pathname, window.location.origin);
//     for (const [key, value] of urlParameters) url.searchParams.append(key, value);
//     if (inputElement.checked) url.searchParams.delete(inputElement.name, inputElement.value);
//     sectionRenderer.getSectionHTML(this.sectionId, true, url);
//   }, 200);

//   cancelPrefetchPage = () => this.prefetchPage.cancel();

//   #updateSelectedFacetSummary() {
//     if (!this.refs.facetInputs) return;
//     const checkedInputElements = this.refs.facetInputs.filter((input) => input.checked);
//     const details = this.closest('details');
//     const statusComponent = details?.querySelector('facet-status-component');
//     if (!(statusComponent instanceof FacetStatusComponent)) return;
//     statusComponent.updateListSummary(checkedInputElements);
//   }
// }

// if (!customElements.get('facet-inputs-component')) {
//   customElements.define('facet-inputs-component', FacetInputsComponent);
// }

// class PriceFacetComponent extends Component {
//   /** @type {object | null} */
//   #slider = null;

//   /** @type {boolean} */
//   #isSliding = false;

//   /** @type {boolean} */
//   #inputListenersAttached = false;

//   /** @type {number | null} */
//   #retryTimer = null;

//   // Helper — strips currency formatting before parseFloat
//   // e.g. "1,558.00" → 1558, "1.558,00" → 1558
//   #cleanValue(val) {
//     if (!val) return 0;
//     return parseFloat(String(val).replace(/[^0-9.]/g, '')) || 0;
//   }

//   connectedCallback() {
//     super.connectedCallback();
//     this.addEventListener('keydown', this.#onKeyDown);
//     this.initSlider();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     this.removeEventListener('keydown', this.#onKeyDown);
//     if (this.#retryTimer) clearTimeout(this.#retryTimer);
//     this.#destroySlider();
//   }

//   /**
//    * Public — called by FacetsFormComponent after section re-render
//    */
//   initSlider() {
//     if (typeof noUiSlider === 'undefined') {
//       this.#retryTimer = setTimeout(() => this.initSlider(), 100);
//       return;
//     }

//     const sliderEl = this.querySelector('.price-facet__slider');
//     if (!sliderEl) return;

//     // Destroy previous instance — fixes hidden-after-rerender
//     if (sliderEl.noUiSlider) {
//       sliderEl.noUiSlider.destroy();
//     }

//     // Force visible
//     sliderEl.style.cssText =
//       'display:block!important;visibility:visible!important;opacity:1!important;';

//     // rangeMax comes from Liquid divided_by:100 so it's already a whole number
//     const rangeMax = parseFloat(this.dataset.rangeMax) || 100;

//     const { minInput, maxInput } = this.refs;
//     if (!minInput || !maxInput) return;

//     // Use dataset start values (set by Liquid divided_by:100) as the
//     // source of truth, not the formatted input values which have commas
//     const startMin = parseFloat(this.dataset.startMin) || 0;
//     const startMax = parseFloat(this.dataset.startMax) || rangeMax;

//     noUiSlider.create(sliderEl, {
//       start: [startMin, startMax],
//       connect: true,
//       step: 1,
//       range: { min: 0, max: rangeMax === 0 ? 100 : rangeMax },
//     });

//     this.#slider = sliderEl.noUiSlider;

//     // Slider → inputs (live while dragging)
//     this.#slider.on('update', (values, handle) => {
//       if (handle === 0) minInput.value = Math.round(parseFloat(values[0]));
//       if (handle === 1) maxInput.value = Math.round(parseFloat(values[1]));
//     });

//     // Slider → AJAX (fires only after drag ends)
//     this.#slider.on('change', (values) => {
//       minInput.value = Math.round(parseFloat(values[0]));
//       maxInput.value = Math.round(parseFloat(values[1]));
//       minInput.dispatchEvent(new Event('change', { bubbles: true }));
//     });

//     this.#slider.on('start', () => { this.#isSliding = true; });
//     this.#slider.on('end',   () => { this.#isSliding = false; });

//     // Inputs → slider (attach only once)
//     if (!this.#inputListenersAttached) {
//       minInput.addEventListener('change', () => {
//         if (this.#isSliding || !this.#slider) return;
//         const val = this.#cleanValue(minInput.value);
//         if (!isNaN(val)) this.#slider.set([val, null]);
//       });
//       maxInput.addEventListener('change', () => {
//         if (this.#isSliding || !this.#slider) return;
//         const val = this.#cleanValue(maxInput.value);
//         if (!isNaN(val)) this.#slider.set([null, val]);
//       });
//       this.#inputListenersAttached = true;
//     }
//   }

//   #destroySlider() {
//     const sliderEl = this.querySelector('.price-facet__slider');
//     if (sliderEl?.noUiSlider) {
//       sliderEl.noUiSlider.destroy();
//     }
//     this.#slider = null;
//     this.#inputListenersAttached = false;
//   }

//   #onKeyDown = (event) => {
//     if (event.metaKey) return;
//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   };

//   updatePriceFilterAndResults() {
//     const { minInput, maxInput } = this.refs;

//     this.#adjustToValidValues(minInput);
//     this.#adjustToValidValues(maxInput);

//     const facetsForm = this.closest('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;

//     facetsForm.updateFilters();
//     this.#setMinAndMaxValues();
//     this.#updateSummary();

//     // Sync slider handles to clamped input values
//     if (this.#slider && !this.#isSliding) {
//       this.#slider.set([
//         this.#cleanValue(minInput.value) || 0,
//         this.#cleanValue(maxInput.value) || parseFloat(this.dataset.rangeMax) || 100,
//       ]);
//     }
//   }

//   #adjustToValidValues(input) {
//     if (input.value.trim() === '') return;
//     const value = Number(this.#cleanValue(input.value));
//     const min = Number(formatMoney(input.getAttribute('data-min') ?? ''));
//     const max = Number(formatMoney(input.getAttribute('data-max') ?? ''));
//     if (value < min) input.value = min.toString();
//     if (value > max) input.value = max.toString();
//   }

//   #setMinAndMaxValues() {
//     const { minInput, maxInput } = this.refs;
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', '0');
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max') ?? '');
//   }

//   #updateSummary() {
//     const { minInput, maxInput } = this.refs;
//     const details = this.closest('details');
//     const statusComponent = details?.querySelector('facet-status-component');
//     if (!(statusComponent instanceof FacetStatusComponent)) return;
//     statusComponent?.updatePriceSummary(minInput, maxInput);
//   }
// }

// if (!customElements.get('price-facet-component')) {
//   customElements.define('price-facet-component', PriceFacetComponent);
// }

// class FacetClearComponent extends Component {
//   requiredRefs = ['clearButton'];

//   connectedCallback() {
//     super.connectedCallback();
//     this.addEventListener('keyup', this.#handleKeyUp);
//     document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   clearFilter(event) {
//     if (!(event.target instanceof HTMLElement)) return;
//     if (event instanceof KeyboardEvent) {
//       if (event.key !== 'Enter' && event.key !== ' ') return;
//       event.preventDefault();
//     }

//     const container = event.target.closest('facet-inputs-component, price-facet-component');
//     container?.querySelectorAll('[type="checkbox"]:checked, input').forEach((input) => {
//       if (input instanceof HTMLInputElement) {
//         input.checked = false;
//         input.value = '';
//       }
//     });

//     const details = event.target.closest('details');
//     const statusComponent = details?.querySelector('facet-status-component');
//     if (!(statusComponent instanceof FacetStatusComponent)) return;
//     statusComponent.clearSummary();

//     const facetsForm = this.closest('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;
//     facetsForm.updateFilters();
//   }

//   #handleKeyUp = (event) => {
//     if (event.metaKey) return;
//     if (event.key === 'Enter') this.clearFilter(event);
//   };

//   #handleFilterUpdate = (event) => {
//     const { clearButton } = this.refs;
//     if (clearButton instanceof Element) {
//       clearButton.classList.toggle('facets__clear--active', event.shouldShowClearAll());
//     }
//   };
// }

// if (!customElements.get('facet-clear-component')) {
//   customElements.define('facet-clear-component', FacetClearComponent);
// }

// class FacetRemoveComponent extends Component {
//   connectedCallback() {
//     super.connectedCallback();
//     document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   removeFilter({ form }, event) {
//     if (event instanceof KeyboardEvent) {
//       if (event.key !== 'Enter' && event.key !== ' ') return;
//       event.preventDefault();
//     }
//     const url = this.dataset.url;
//     if (!url) return;
//     const facetsForm = form ? document.getElementById(form) : this.closest('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;
//     facetsForm.updateFiltersByURL(url);
//   }

//   #handleFilterUpdate = (event) => {
//     const { clearButton } = this.refs;
//     if (clearButton instanceof Element) {
//       clearButton.classList.toggle('active', event.shouldShowClearAll());
//     }
//   };
// }

// if (!customElements.get('facet-remove-component')) {
//   customElements.define('facet-remove-component', FacetRemoveComponent);
// }

// class SortingFilterComponent extends Component {
//   requiredRefs = ['details', 'summary', 'listbox'];

//   handleKeyDown = (event) => {
//     const { listbox } = this.refs;
//     if (!(listbox instanceof Element)) return;
//     const options = Array.from(listbox.querySelectorAll('[role="option"]'));
//     const currentFocused = options.find((option) => option instanceof HTMLElement && option.tabIndex === 0);
//     let newFocusIndex = currentFocused ? options.indexOf(currentFocused) : 0;

//     switch (event.key) {
//       case 'ArrowDown':
//         event.preventDefault();
//         newFocusIndex = Math.min(newFocusIndex + 1, options.length - 1);
//         this.#moveFocus(options, newFocusIndex);
//         break;
//       case 'ArrowUp':
//         event.preventDefault();
//         newFocusIndex = Math.max(newFocusIndex - 1, 0);
//         this.#moveFocus(options, newFocusIndex);
//         break;
//       case 'Enter':
//       case ' ':
//         if (event.target instanceof Element) {
//           const targetOption = event.target.closest('[role="option"]');
//           if (targetOption) {
//             event.preventDefault();
//             this.#selectOption(targetOption);
//           }
//         }
//         break;
//       case 'Escape':
//         event.preventDefault();
//         this.#closeDropdown();
//         break;
//     }
//   };

//   handleToggle = () => {
//     const { details, summary, listbox } = this.refs;
//     if (!(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) return;
//     const isOpen = details.open;
//     summary.setAttribute('aria-expanded', isOpen.toString());
//     if (isOpen && listbox instanceof Element) {
//       const selectedOption = listbox.querySelector('[aria-selected="true"]');
//       if (selectedOption instanceof HTMLElement) selectedOption.focus();
//     }
//   };

//   #moveFocus(options, newIndex) {
//     options.forEach((option) => {
//       if (option instanceof HTMLElement) option.tabIndex = -1;
//     });
//     const targetOption = options[newIndex];
//     if (targetOption instanceof HTMLElement) {
//       targetOption.tabIndex = 0;
//       targetOption.focus();
//     }
//   }

//   #selectOption(option) {
//     const input = option.querySelector('input[type="radio"]');
//     if (input instanceof HTMLInputElement && option instanceof HTMLElement) {
//       this.querySelectorAll('[role="option"]').forEach((opt) => {
//         opt.setAttribute('aria-selected', 'false');
//       });
//       option.setAttribute('aria-selected', 'true');
//       input.click();
//       this.#closeDropdown();
//     }
//   }

//   #closeDropdown() {
//     const { details, summary } = this.refs;
//     if (details instanceof HTMLDetailsElement) {
//       const options = this.querySelectorAll('[role="option"]');
//       const selectedOption = this.querySelector('[aria-selected="true"]');
//       options.forEach((opt) => {
//         if (opt instanceof HTMLElement) opt.tabIndex = -1;
//       });
//       if (selectedOption instanceof HTMLElement) selectedOption.tabIndex = 0;
//       details.open = false;
//       if (summary instanceof HTMLElement) summary.focus();
//     }
//   }

//   updateFilterAndSorting(event) {
//     const facetsForm =
//       this.closest('facets-form-component') || this.closest('.shopify-section')?.querySelector('facets-form-component');
//     if (!(facetsForm instanceof FacetsFormComponent)) return;

//     const isMobile = window.innerWidth < 750;
//     const shouldDisable = this.dataset.shouldUseSelectOnMobile === 'true';

//     if (shouldDisable) {
//       if (isMobile) {
//         this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
//           if (input instanceof HTMLInputElement) input.disabled = true;
//         });
//       } else {
//         const selectElement = this.querySelector('select[name="sort_by"]');
//         if (selectElement instanceof HTMLSelectElement) selectElement.disabled = true;
//       }
//     }

//     facetsForm.updateFilters();
//     this.updateFacetStatus(event);

//     if (shouldDisable) {
//       if (isMobile) {
//         this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
//           if (input instanceof HTMLInputElement) input.disabled = false;
//         });
//       } else {
//         const selectElement = this.querySelector('select[name="sort_by"]');
//         if (selectElement instanceof HTMLSelectElement) selectElement.disabled = false;
//       }
//     }

//     const { details } = this.refs;
//     if (!(details instanceof HTMLDetailsElement)) return;
//     details.open = false;
//   }

//   updateFacetStatus(event) {
//     if (!(event.target instanceof HTMLSelectElement)) return;
//     const details = this.querySelector('details');
//     if (!details) return;
//     const facetStatus = details.querySelector('facet-status-component');
//     if (!(facetStatus instanceof FacetStatusComponent)) return;
//     facetStatus.textContent =
//       event.target.value !== details.dataset.defaultSortBy ? event.target.dataset.optionName ?? '' : '';
//   }
// }

// if (!customElements.get('sorting-filter-component')) {
//   customElements.define('sorting-filter-component', SortingFilterComponent);
// }

// class FacetStatusComponent extends Component {
//   updateListSummary(checkedInputElements) {
//     const checkedInputElementsCount = checkedInputElements.length;
//     this.getAttribute('facet-type') === 'swatches'
//       ? this.#updateSwatchSummary(checkedInputElements, checkedInputElementsCount)
//       : this.#updateBubbleSummary(checkedInputElements, checkedInputElementsCount);
//   }

//   #updateSwatchSummary(checkedInputElements, checkedInputElementsCount) {
//     const { facetStatus } = this.refs;
//     facetStatus.classList.remove('bubble', 'facets__bubble');
//     if (checkedInputElementsCount === 0) { facetStatus.innerHTML = ''; return; }
//     if (checkedInputElementsCount > 3) {
//       facetStatus.innerHTML = checkedInputElementsCount.toString();
//       facetStatus.classList.add('bubble', 'facets__bubble');
//       return;
//     }
//     facetStatus.innerHTML = Array.from(checkedInputElements)
//       .map((inputElement) => {
//         const swatch = inputElement.parentElement?.querySelector('span.swatch');
//         return swatch?.outerHTML ?? '';
//       })
//       .join('');
//   }

//   #updateBubbleSummary(checkedInputElements, checkedInputElementsCount) {
//     const { facetStatus } = this.refs;
//     facetStatus.classList.remove('bubble', 'facets__bubble');
//     if (checkedInputElementsCount === 0) { facetStatus.innerHTML = ''; return; }
//     if (checkedInputElementsCount === 1) {
//       facetStatus.innerHTML = checkedInputElements[0]?.dataset.label ?? '';
//       return;
//     }
//     facetStatus.innerHTML = checkedInputElementsCount.toString();
//     facetStatus.classList.add('bubble', 'facets__bubble');
//   }

//   updatePriceSummary(minInput, maxInput) {
//     const minInputValue = minInput.value;
//     const maxInputValue = maxInput.value;
//     const { facetStatus } = this.refs;
//     if (!minInputValue && !maxInputValue) { facetStatus.innerHTML = ''; return; }
//     const minInputNum = this.#parseCents(minInputValue, '0');
//     const maxInputNum = this.#parseCents(maxInputValue, facetStatus.dataset.rangeMax);
//     facetStatus.innerHTML = `${this.#formatMoney(minInputNum)}–${this.#formatMoney(maxInputNum)}`;
//   }

//   #parseCents(value, fallback = '0') {
//     const parts = value ? value.trim().split(/[^0-9]/) : (parseInt(fallback, 10) / 100).toString();
//     const [wholeStr, fractionStr, ...rest] = parts;
//     if (typeof wholeStr !== 'string' || rest.length > 0) return parseInt(fallback, 10);
//     const whole = parseInt(wholeStr, 10);
//     let fraction = parseInt(fractionStr || '0', 10);
//     fraction = fraction * Math.pow(10, 2 - fraction.toString().length);
//     return whole * 100 + fraction;
//   }

//   #formatMoney(moneyValue) {
//     if (!(this.refs.moneyFormat instanceof HTMLTemplateElement)) return '';
//     const template = this.refs.moneyFormat.content.textContent || '{{amount}}';
//     const currency = this.refs.facetStatus.dataset.currency || '';
//     return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
//       if (typeof placeholder !== 'string') return '';
//       if (placeholder === 'currency') return currency;
//       let thousandsSeparator = ',';
//       let decimalSeparator = '.';
//       let precision = CURRENCY_DECIMALS[currency.toUpperCase()] ?? DEFAULT_CURRENCY_DECIMALS;
//       if (placeholder === 'amount_no_decimals') { precision = 0; }
//       else if (placeholder === 'amount_with_comma_separator') { thousandsSeparator = '.'; decimalSeparator = ','; }
//       else if (placeholder === 'amount_no_decimals_with_comma_separator') { thousandsSeparator = '.'; precision = 0; }
//       else if (placeholder === 'amount_no_decimals_with_space_separator') { thousandsSeparator = ' '; precision = 0; }
//       else if (placeholder === 'amount_with_space_separator') { thousandsSeparator = ' '; decimalSeparator = ','; }
//       else if (placeholder === 'amount_with_period_and_space_separator') { thousandsSeparator = ' '; decimalSeparator = '.'; }
//       else if (placeholder === 'amount_with_apostrophe_separator') { thousandsSeparator = "'"; decimalSeparator = '.'; }
//       return this.#formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision);
//     });
//   }

//   #formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
//     const roundedNumber = (moneyValue / 100).toFixed(precision);
//     let [a, b] = roundedNumber.split('.');
//     if (!a) a = '0';
//     if (!b) b = '';
//     a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);
//     return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
//   }

//   clearSummary() {
//     this.refs.facetStatus.innerHTML = '';
//   }
// }

// if (!customElements.get('facet-status-component')) {
//   customElements.define('facet-status-component', FacetStatusComponent);
// }

// const DEFAULT_CURRENCY_DECIMALS = 2;

// const CURRENCY_DECIMALS = {
//   BHD: 3, BIF: 0, BYR: 0, CLF: 4, CLP: 0, DJF: 0, GNF: 0,
//   IQD: 3, ISK: 0, JOD: 3, JPY: 0, KMF: 0, KRW: 0, KWD: 3,
//   LYD: 3, MRO: 5, OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0,
//   UYI: 0, UYW: 4, VND: 0, VUV: 0, XAF: 0, XAG: 0, XAU: 0,
//   XBA: 0, XBB: 0, XBC: 0, XBD: 0, XDR: 0, XOF: 0, XPD: 0,
//   XPF: 0, XPT: 0, XSU: 0, XTS: 0, XUA: 0,
// };

import { sectionRenderer } from '@theme/section-renderer';
import { Component } from '@theme/component';
import { FilterUpdateEvent, ThemeEvents } from '@theme/events';
import { debounce, formatMoney, startViewTransition } from '@theme/utilities';

const SEARCH_QUERY = 'q';

class FacetsFormComponent extends Component {
  requiredRefs = ['facetsForm'];

  createURLParameters(formData = new FormData(this.refs.facetsForm)) {
    let newParameters = new URLSearchParams(/** @type any */ (formData));

    // FIX 1: Only strip price params when the user has NOT deliberately
    // set a price filter. If userHasSetPrice is true the values are
    // intentional and must be preserved exactly as-is.
    // When userHasSetPrice is false the inputs hold initialised defaults
    // (set by the slider on mount) — strip them so unrelated actions like
    // sort or checkbox filters never accidentally inject price into the URL.
    const priceFacet = this.querySelector('price-facet-component[data-range-max]');
    if (priceFacet instanceof PriceFacetComponent) {
      if (!priceFacet.userHasSetPrice) {
        // User has NOT set a price filter — remove both price params
        // regardless of their value (they are just slider defaults).
        newParameters.delete('filter.v.price.gte');
        newParameters.delete('filter.v.price.lte');
      }
      // If userHasSetPrice is true we leave the params untouched —
      // the exact values the user chose are already in formData.
    } else {
      // Original guard for non-slider price inputs
      if (newParameters.get('filter.v.price.gte') === '') newParameters.delete('filter.v.price.gte');
      if (newParameters.get('filter.v.price.lte') === '') newParameters.delete('filter.v.price.lte');
    }

    newParameters.delete('page');

    const searchQuery = this.#getSearchQuery();
    if (searchQuery) newParameters.set(SEARCH_QUERY, searchQuery);

    return newParameters;
  }

  #getSearchQuery() {
    const url = new URL(window.location.href);
    return url.searchParams.get(SEARCH_QUERY) ?? '';
  }

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('Section ID is required');
    return id;
  }

  #updateURLHash() {
    const url = new URL(window.location.href);
    const urlParameters = this.createURLParameters();

    url.search = '';
    for (const [param, value] of urlParameters.entries()) {
      url.searchParams.append(param, value);
    }

    history.pushState({ urlParameters: urlParameters.toString() }, '', url.toString());
  }

  updateFilters = () => {
    this.#updateURLHash();
    this.dispatchEvent(new FilterUpdateEvent(this.createURLParameters()));
    this.#updateSection();
  };

  #updateSection() {
    const viewTransition = !this.closest('dialog');

    const afterRender = () => {
      document.querySelectorAll('price-facet-component[data-range-max]').forEach((el) => {
        if (el instanceof PriceFacetComponent) el.initSlider();
      });
    };

    if (viewTransition) {
      startViewTransition(
        () => sectionRenderer.renderSection(this.sectionId).then(afterRender),
        ['product-grid']
      );
    } else {
      sectionRenderer.renderSection(this.sectionId).then(afterRender);
    }
  }

  updateFiltersByURL(url) {
    history.pushState('', '', url);
    this.dispatchEvent(new FilterUpdateEvent(this.createURLParameters()));
    this.#updateSection();
  }
}

if (!customElements.get('facets-form-component')) {
  customElements.define('facets-form-component', FacetsFormComponent);
}

class FacetInputsComponent extends Component {
  get sectionId() {
    const id = this.closest('.shopify-section')?.id;
    if (!id) throw new Error('FacetInputs component must be a child of a section');
    return id;
  }

  updateFilters() {
    const facetsForm = this.closest('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
    this.#updateSelectedFacetSummary();
  }

  handleKeyDown(event) {
    if (!(event.target instanceof HTMLElement)) return;
    const closestInput = event.target.querySelector('input');
    if (!(closestInput instanceof HTMLInputElement)) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      closestInput.checked = !closestInput.checked;
      this.updateFilters();
    }
  }

  prefetchPage = debounce((event) => {
    if (!(event.target instanceof HTMLElement)) return;
    const form = this.closest('form');
    if (!form) return;
    const formData = new FormData(form);
    const inputElement = event.target.querySelector('input');
    if (!(inputElement instanceof HTMLInputElement)) return;
    if (!inputElement.checked) formData.append(inputElement.name, inputElement.value);
    const facetsForm = this.closest('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    const urlParameters = facetsForm.createURLParameters(formData);
    const url = new URL(window.location.pathname, window.location.origin);
    for (const [key, value] of urlParameters) url.searchParams.append(key, value);
    if (inputElement.checked) url.searchParams.delete(inputElement.name, inputElement.value);
    sectionRenderer.getSectionHTML(this.sectionId, true, url);
  }, 200);

  cancelPrefetchPage = () => this.prefetchPage.cancel();

  #updateSelectedFacetSummary() {
    if (!this.refs.facetInputs) return;
    const checkedInputElements = this.refs.facetInputs.filter((input) => input.checked);
    const details = this.closest('details');
    const statusComponent = details?.querySelector('facet-status-component');
    if (!(statusComponent instanceof FacetStatusComponent)) return;
    statusComponent.updateListSummary(checkedInputElements);
  }
}

if (!customElements.get('facet-inputs-component')) {
  customElements.define('facet-inputs-component', FacetInputsComponent);
}

class PriceFacetComponent extends Component {
  /** @type {object | null} */
  #slider = null;

  /** @type {boolean} */
  #isSliding = false;

  /** @type {boolean} */
  #inputListenersAttached = false;

  /** @type {number | null} */
  #retryTimer = null;

  // FIX 2: Track whether the user has actively moved the price slider
  // away from its defaults. We only want to treat a price change as a
  // real filter if the user actually interacted with it — NOT when the
  // slider is simply initialised with default start/end values.
  /** @type {boolean} */
  #userHasSetPrice = false;

  // Helper — strips currency formatting before parseFloat
  #cleanValue(val) {
    if (!val) return 0;
    return parseFloat(String(val).replace(/[^0-9.]/g, '')) || 0;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#onKeyDown);
    this.initSlider();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#onKeyDown);
    if (this.#retryTimer) clearTimeout(this.#retryTimer);
    this.#destroySlider();
  }

  /**
   * Public — called by FacetsFormComponent after section re-render.
   * Also restores #userHasSetPrice from the current URL so that a
   * re-render after a price filter does not reset the active state.
   */
  initSlider() {
    if (typeof noUiSlider === 'undefined') {
      this.#retryTimer = setTimeout(() => this.initSlider(), 100);
      return;
    }

    const sliderEl = this.querySelector('.price-facet__slider');
    if (!sliderEl) return;

    if (sliderEl.noUiSlider) {
      sliderEl.noUiSlider.destroy();
    }

    sliderEl.style.cssText =
      'display:block!important;visibility:visible!important;opacity:1!important;';

    const rangeMax = parseFloat(this.dataset.rangeMax) || 100;

    const { minInput, maxInput } = this.refs;
    if (!minInput || !maxInput) return;

    const startMin = parseFloat(this.dataset.startMin) || 0;
    const startMax = parseFloat(this.dataset.startMax) || rangeMax;

    // FIX 2 (cont.): Detect from the live URL whether a price filter is
    // already active so the flag survives section re-renders.
    const urlParams = new URLSearchParams(window.location.search);
    const urlGte = urlParams.get('filter.v.price.gte');
    const urlLte = urlParams.get('filter.v.price.lte');
    this.#userHasSetPrice =
      (urlGte !== null && urlGte !== '' && parseFloat(urlGte) !== 0) ||
      (urlLte !== null && urlLte !== '' && parseFloat(urlLte) !== rangeMax);

    noUiSlider.create(sliderEl, {
      start: [startMin, startMax],
      connect: true,
      step: 1,
      range: { min: 0, max: rangeMax === 0 ? 100 : rangeMax },
    });

    this.#slider = sliderEl.noUiSlider;

    // Slider → inputs (live while dragging, no AJAX)
    this.#slider.on('update', (values, handle) => {
      if (handle === 0) minInput.value = Math.round(parseFloat(values[0]));
      if (handle === 1) maxInput.value = Math.round(parseFloat(values[1]));
    });

    // Slider → AJAX (fires only after drag ends)
    this.#slider.on('change', (values) => {
      // FIX 2 (cont.): Mark that the user has deliberately moved the
      // slider before we commit the price to the URL / AJAX call.
      this.#userHasSetPrice = true;

      minInput.value = Math.round(parseFloat(values[0]));
      maxInput.value = Math.round(parseFloat(values[1]));
      // Dispatch on minInput only — updatePriceFilterAndResults handles both
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.#slider.on('start', () => { this.#isSliding = true; });
    this.#slider.on('end',   () => { this.#isSliding = false; });

    // Inputs → slider (attach only once per element lifetime)
    if (!this.#inputListenersAttached) {
      minInput.addEventListener('change', () => {
        if (this.#isSliding || !this.#slider) return;
        const val = this.#cleanValue(minInput.value);
        if (!isNaN(val)) this.#slider.set([val, null]);
      });
      maxInput.addEventListener('change', () => {
        if (this.#isSliding || !this.#slider) return;
        const val = this.#cleanValue(maxInput.value);
        if (!isNaN(val)) this.#slider.set([null, val]);
      });
      this.#inputListenersAttached = true;
    }
  }

  #destroySlider() {
    const sliderEl = this.querySelector('.price-facet__slider');
    if (sliderEl?.noUiSlider) {
      sliderEl.noUiSlider.destroy();
    }
    this.#slider = null;
    this.#inputListenersAttached = false;
  }

  #onKeyDown = (event) => {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  };

  updatePriceFilterAndResults() {
    const { minInput, maxInput } = this.refs;

    this.#adjustToValidValues(minInput);
    this.#adjustToValidValues(maxInput);

    // FIX 2 (cont.): Mark as user-set when typing directly into the
    // inputs (not just slider drag).
    this.#userHasSetPrice = true;

    const facetsForm = this.closest('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;

    facetsForm.updateFilters();
    this.#setMinAndMaxValues();
    this.#updateSummary();

    if (this.#slider && !this.#isSliding) {
      this.#slider.set([
        this.#cleanValue(minInput.value) || 0,
        this.#cleanValue(maxInput.value) || parseFloat(this.dataset.rangeMax) || 100,
      ]);
    }
  }

  /**
   * Public getter used by FacetsFormComponent.createURLParameters to
   * decide whether to include price params in the URL.
   */
  get userHasSetPrice() {
    return this.#userHasSetPrice;
  }

  #adjustToValidValues(input) {
    if (input.value.trim() === '') return;
    const value = Number(this.#cleanValue(input.value));
    const min = Number(formatMoney(input.getAttribute('data-min') ?? ''));
    const max = Number(formatMoney(input.getAttribute('data-max') ?? ''));
    if (value < min) input.value = min.toString();
    if (value > max) input.value = max.toString();
  }

  #setMinAndMaxValues() {
    const { minInput, maxInput } = this.refs;
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', '0');
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max') ?? '');
  }

  #updateSummary() {
    const { minInput, maxInput } = this.refs;
    const details = this.closest('details');
    const statusComponent = details?.querySelector('facet-status-component');
    if (!(statusComponent instanceof FacetStatusComponent)) return;
    statusComponent?.updatePriceSummary(minInput, maxInput);
  }
}

if (!customElements.get('price-facet-component')) {
  customElements.define('price-facet-component', PriceFacetComponent);
}

class FacetClearComponent extends Component {
  requiredRefs = ['clearButton'];

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keyup', this.#handleKeyUp);
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  clearFilter(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event instanceof KeyboardEvent) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
    }

    const container = event.target.closest('facet-inputs-component, price-facet-component');
    container?.querySelectorAll('[type="checkbox"]:checked, input').forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.checked = false;
        input.value = '';
      }
    });

    // FIX 3: When clearing the price facet, also reset #userHasSetPrice
    // so subsequent sort/filter changes don't re-inject a stale price range.
    const priceFacet = container instanceof PriceFacetComponent
      ? container
      : container?.closest('price-facet-component');
    if (priceFacet instanceof PriceFacetComponent) {
      // Reset via re-init — destroys the slider and clears the flag
      priceFacet.initSlider();
    }

    const details = event.target.closest('details');
    const statusComponent = details?.querySelector('facet-status-component');
    if (!(statusComponent instanceof FacetStatusComponent)) return;
    statusComponent.clearSummary();

    const facetsForm = this.closest('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
  }

  #handleKeyUp = (event) => {
    if (event.metaKey) return;
    if (event.key === 'Enter') this.clearFilter(event);
  };

  #handleFilterUpdate = (event) => {
    const { clearButton } = this.refs;
    if (clearButton instanceof Element) {
      clearButton.classList.toggle('facets__clear--active', event.shouldShowClearAll());
    }
  };
}

if (!customElements.get('facet-clear-component')) {
  customElements.define('facet-clear-component', FacetClearComponent);
}

class FacetRemoveComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  removeFilter({ form }, event) {
    if (event instanceof KeyboardEvent) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
    }
    const url = this.dataset.url;
    if (!url) return;
    const facetsForm = form ? document.getElementById(form) : this.closest('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFiltersByURL(url);
  }

  #handleFilterUpdate = (event) => {
    const { clearButton } = this.refs;
    if (clearButton instanceof Element) {
      clearButton.classList.toggle('active', event.shouldShowClearAll());
    }
  };
}

if (!customElements.get('facet-remove-component')) {
  customElements.define('facet-remove-component', FacetRemoveComponent);
}

class SortingFilterComponent extends Component {
  requiredRefs = ['details', 'summary', 'listbox'];

  handleKeyDown = (event) => {
    const { listbox } = this.refs;
    if (!(listbox instanceof Element)) return;
    const options = Array.from(listbox.querySelectorAll('[role="option"]'));
    const currentFocused = options.find((option) => option instanceof HTMLElement && option.tabIndex === 0);
    let newFocusIndex = currentFocused ? options.indexOf(currentFocused) : 0;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        newFocusIndex = Math.min(newFocusIndex + 1, options.length - 1);
        this.#moveFocus(options, newFocusIndex);
        break;
      case 'ArrowUp':
        event.preventDefault();
        newFocusIndex = Math.max(newFocusIndex - 1, 0);
        this.#moveFocus(options, newFocusIndex);
        break;
      case 'Enter':
      case ' ':
        if (event.target instanceof Element) {
          const targetOption = event.target.closest('[role="option"]');
          if (targetOption) {
            event.preventDefault();
            this.#selectOption(targetOption);
          }
        }
        break;
      case 'Escape':
        event.preventDefault();
        this.#closeDropdown();
        break;
    }
  };

  handleToggle = () => {
    const { details, summary, listbox } = this.refs;
    if (!(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) return;
    const isOpen = details.open;
    summary.setAttribute('aria-expanded', isOpen.toString());
    if (isOpen && listbox instanceof Element) {
      const selectedOption = listbox.querySelector('[aria-selected="true"]');
      if (selectedOption instanceof HTMLElement) selectedOption.focus();
    }
  };

  #moveFocus(options, newIndex) {
    options.forEach((option) => {
      if (option instanceof HTMLElement) option.tabIndex = -1;
    });
    const targetOption = options[newIndex];
    if (targetOption instanceof HTMLElement) {
      targetOption.tabIndex = 0;
      targetOption.focus();
    }
  }

  #selectOption(option) {
    const input = option.querySelector('input[type="radio"]');
    if (input instanceof HTMLInputElement && option instanceof HTMLElement) {
      this.querySelectorAll('[role="option"]').forEach((opt) => {
        opt.setAttribute('aria-selected', 'false');
      });
      option.setAttribute('aria-selected', 'true');
      input.click();
      this.#closeDropdown();
    }
  }

  #closeDropdown() {
    const { details, summary } = this.refs;
    if (details instanceof HTMLDetailsElement) {
      const options = this.querySelectorAll('[role="option"]');
      const selectedOption = this.querySelector('[aria-selected="true"]');
      options.forEach((opt) => {
        if (opt instanceof HTMLElement) opt.tabIndex = -1;
      });
      if (selectedOption instanceof HTMLElement) selectedOption.tabIndex = 0;
      details.open = false;
      if (summary instanceof HTMLElement) summary.focus();
    }
  }

  updateFilterAndSorting(event) {
    const facetsForm =
      this.closest('facets-form-component') || this.closest('.shopify-section')?.querySelector('facets-form-component');
    if (!(facetsForm instanceof FacetsFormComponent)) return;

    const isMobile = window.innerWidth < 750;
    const shouldDisable = this.dataset.shouldUseSelectOnMobile === 'true';

    if (shouldDisable) {
      if (isMobile) {
        this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
          if (input instanceof HTMLInputElement) input.disabled = true;
        });
      } else {
        const selectElement = this.querySelector('select[name="sort_by"]');
        if (selectElement instanceof HTMLSelectElement) selectElement.disabled = true;
      }
    }

    // FIX 4: Before calling updateFilters (which serialises the whole
    // form), temporarily blank out the price inputs if the user has NOT
    // deliberately set a price filter. This prevents the sort action
    // from injecting the slider's initialised default values into the URL.
    const priceFacet = facetsForm.querySelector('price-facet-component[data-range-max]');
    /** @type {string} */ let savedMin = '';
    /** @type {string} */ let savedMax = '';

    if (priceFacet instanceof PriceFacetComponent && !priceFacet.userHasSetPrice) {
      const { minInput, maxInput } = priceFacet.refs;
      if (minInput instanceof HTMLInputElement && maxInput instanceof HTMLInputElement) {
        savedMin = minInput.value;
        savedMax = maxInput.value;
        minInput.value = '';
        maxInput.value = '';
      }
    }

    facetsForm.updateFilters();

    // Restore input values so the slider UI stays intact
    if (priceFacet instanceof PriceFacetComponent && !priceFacet.userHasSetPrice) {
      const { minInput, maxInput } = priceFacet.refs;
      if (minInput instanceof HTMLInputElement) minInput.value = savedMin;
      if (maxInput instanceof HTMLInputElement) maxInput.value = savedMax;
    }

    this.updateFacetStatus(event);

    if (shouldDisable) {
      if (isMobile) {
        this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
          if (input instanceof HTMLInputElement) input.disabled = false;
        });
      } else {
        const selectElement = this.querySelector('select[name="sort_by"]');
        if (selectElement instanceof HTMLSelectElement) selectElement.disabled = false;
      }
    }

    const { details } = this.refs;
    if (!(details instanceof HTMLDetailsElement)) return;
    details.open = false;
  }

  updateFacetStatus(event) {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const details = this.querySelector('details');
    if (!details) return;
    const facetStatus = details.querySelector('facet-status-component');
    if (!(facetStatus instanceof FacetStatusComponent)) return;
    facetStatus.textContent =
      event.target.value !== details.dataset.defaultSortBy ? event.target.dataset.optionName ?? '' : '';
  }
}

if (!customElements.get('sorting-filter-component')) {
  customElements.define('sorting-filter-component', SortingFilterComponent);
}

class FacetStatusComponent extends Component {
  updateListSummary(checkedInputElements) {
    const checkedInputElementsCount = checkedInputElements.length;
    this.getAttribute('facet-type') === 'swatches'
      ? this.#updateSwatchSummary(checkedInputElements, checkedInputElementsCount)
      : this.#updateBubbleSummary(checkedInputElements, checkedInputElementsCount);
  }

  #updateSwatchSummary(checkedInputElements, checkedInputElementsCount) {
    const { facetStatus } = this.refs;
    facetStatus.classList.remove('bubble', 'facets__bubble');
    if (checkedInputElementsCount === 0) { facetStatus.innerHTML = ''; return; }
    if (checkedInputElementsCount > 3) {
      facetStatus.innerHTML = checkedInputElementsCount.toString();
      facetStatus.classList.add('bubble', 'facets__bubble');
      return;
    }
    facetStatus.innerHTML = Array.from(checkedInputElements)
      .map((inputElement) => {
        const swatch = inputElement.parentElement?.querySelector('span.swatch');
        return swatch?.outerHTML ?? '';
      })
      .join('');
  }

  #updateBubbleSummary(checkedInputElements, checkedInputElementsCount) {
    const { facetStatus } = this.refs;
    facetStatus.classList.remove('bubble', 'facets__bubble');
    if (checkedInputElementsCount === 0) { facetStatus.innerHTML = ''; return; }
    if (checkedInputElementsCount === 1) {
      facetStatus.innerHTML = checkedInputElements[0]?.dataset.label ?? '';
      return;
    }
    facetStatus.innerHTML = checkedInputElementsCount.toString();
    facetStatus.classList.add('bubble', 'facets__bubble');
  }

  updatePriceSummary(minInput, maxInput) {
    const minInputValue = minInput.value;
    const maxInputValue = maxInput.value;
    const { facetStatus } = this.refs;
    if (!minInputValue && !maxInputValue) { facetStatus.innerHTML = ''; return; }
    const minInputNum = this.#parseCents(minInputValue, '0');
    const maxInputNum = this.#parseCents(maxInputValue, facetStatus.dataset.rangeMax);
    facetStatus.innerHTML = `${this.#formatMoney(minInputNum)}–${this.#formatMoney(maxInputNum)}`;
  }

  #parseCents(value, fallback = '0') {
    const parts = value ? value.trim().split(/[^0-9]/) : (parseInt(fallback, 10) / 100).toString();
    const [wholeStr, fractionStr, ...rest] = parts;
    if (typeof wholeStr !== 'string' || rest.length > 0) return parseInt(fallback, 10);
    const whole = parseInt(wholeStr, 10);
    let fraction = parseInt(fractionStr || '0', 10);
    fraction = fraction * Math.pow(10, 2 - fraction.toString().length);
    return whole * 100 + fraction;
  }

  #formatMoney(moneyValue) {
    if (!(this.refs.moneyFormat instanceof HTMLTemplateElement)) return '';
    const template = this.refs.moneyFormat.content.textContent || '{{amount}}';
    const currency = this.refs.facetStatus.dataset.currency || '';
    return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
      if (typeof placeholder !== 'string') return '';
      if (placeholder === 'currency') return currency;
      let thousandsSeparator = ',';
      let decimalSeparator = '.';
      let precision = CURRENCY_DECIMALS[currency.toUpperCase()] ?? DEFAULT_CURRENCY_DECIMALS;
      if (placeholder === 'amount_no_decimals') { precision = 0; }
      else if (placeholder === 'amount_with_comma_separator') { thousandsSeparator = '.'; decimalSeparator = ','; }
      else if (placeholder === 'amount_no_decimals_with_comma_separator') { thousandsSeparator = '.'; precision = 0; }
      else if (placeholder === 'amount_no_decimals_with_space_separator') { thousandsSeparator = ' '; precision = 0; }
      else if (placeholder === 'amount_with_space_separator') { thousandsSeparator = ' '; decimalSeparator = ','; }
      else if (placeholder === 'amount_with_period_and_space_separator') { thousandsSeparator = ' '; decimalSeparator = '.'; }
      else if (placeholder === 'amount_with_apostrophe_separator') { thousandsSeparator = "'"; decimalSeparator = '.'; }
      return this.#formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision);
    });
  }

  #formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
    const roundedNumber = (moneyValue / 100).toFixed(precision);
    let [a, b] = roundedNumber.split('.');
    if (!a) a = '0';
    if (!b) b = '';
    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);
    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }

  clearSummary() {
    this.refs.facetStatus.innerHTML = '';
  }
}

if (!customElements.get('facet-status-component')) {
  customElements.define('facet-status-component', FacetStatusComponent);
}

const DEFAULT_CURRENCY_DECIMALS = 2;

const CURRENCY_DECIMALS = {
  BHD: 3, BIF: 0, BYR: 0, CLF: 4, CLP: 0, DJF: 0, GNF: 0,
  IQD: 3, ISK: 0, JOD: 3, JPY: 0, KMF: 0, KRW: 0, KWD: 3,
  LYD: 3, MRO: 5, OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0,
  UYI: 0, UYW: 4, VND: 0, VUV: 0, XAF: 0, XAG: 0, XAU: 0,
  XBA: 0, XBB: 0, XBC: 0, XBD: 0, XDR: 0, XOF: 0, XPD: 0,
  XPF: 0, XPT: 0, XSU: 0, XTS: 0, XUA: 0,
};